import { WAIT_FOR_ACTION, ERROR_ACTION, CALLBACK_ERROR_ARGUMENT } from "redux-wait-for-action";

export const SET_ERROR_OCCURRED_WHILE_PERFORMING = "SET_ERROR_OCCURRED_WHILE_PERFORMING";
export const SEARCH_APPLICATIONS_REQUEST = "SEARCH_APPLICATIONS";
export const SEARCH_USER_APPLICATIONS_REQUEST = "SEARCH_USER_APPLICATIONS_REQUEST";
export const SEARCH_APPLICATIONS_SUCCESS = "SEARCH_APPLICATIONS_SUCCESS";
export const SEARCH_APPLICATIONS_FAILURE = "SEARCH_APPLICATIONS_FAILURE";
export const IS_APPLY_EDIT_APPLICATION = "IS_APPLY_EDIT_APPLICATION";
export const GET_PROSPECT_OVERVIEW_REQUEST = "GET_PROSPECT_OVERVIEW_REQUEST";
export const GET_PROSPECT_OVERVIEW_SUCCESS = "GET_PROSPECT_OVERVIEW_SUCCESS";
export const GET_PROSPECT_OVERVIEW_FAIL = "GET_PROSPECT_OVERVIEW_FAIL";
export const LOAD_MORE_SEARCH_APPLICATIONS = "LOAD_MORE_SEARCH_APPLICATIONS";
export const LOAD_MORE_SEARCH_APPLICATIONS_SUCCESS = "LOAD_MORE_SEARCH_APPLICATIONS_SUCCESS";
export const LOAD_MORE_SEARCH_APPLICATIONS_FAILURE = "LOAD_MORE_SEARCH_APPLICATIONS_FAILURE";
export const UPDATE_RO = "UPDATE_RO";
export const UPDATE_RO_SUCCESS = "UPDATE_RO_SUCCESS";
export const UPDATE_RO_FAILURE = "UPDATE_RO_FAILURE";
export const GET_RO_PROSPECT_REQUEST = "GET_RO_PROSPECT_REQUEST";
export const GET_RO_PROSPECT_REQUEST_SUCCESS = "GET_RO_PROSPECT_REQUEST_SUCCESS";
export const GET_RO_PROSPECT_REQUEST_FAILURE = "GET_RO_PROSPECT_REQUEST_FAILURE";
export const RESET_SEARCH_RESULTS = "RESET_SEARCH_RESULTS";
export const SEND_USER_DROPOFF_AUTHORIZE_REQ = "SEND_USER_DROPOFF_AUTHORIZE_REQ";
export const SEND_USER_DROPOFF_AUTHORIZE_REQ_SUCCESS = "SEND_USER_DROPOFF_AUTHORIZE_REQ_SUCCESS";
export const SEND_USER_DROPOFF_AUTHORIZE_REQ_FAIL = "SEND_USER_DROPOFF_AUTHORIZE_REQ_FAIL";

export const searchApplications = data => ({
  type: SEARCH_APPLICATIONS_REQUEST,
  payload: data
});

export const getUserProspectPromisify = data => ({
  type: SEARCH_USER_APPLICATIONS_REQUEST,
  [WAIT_FOR_ACTION]: SEARCH_APPLICATIONS_SUCCESS,
  [ERROR_ACTION]: SEARCH_APPLICATIONS_FAILURE,
  [CALLBACK_ERROR_ARGUMENT]: errorType => errorType.payload,
  payload: data
});

export const searchApplicationsSuccess = data => ({
  type: SEARCH_APPLICATIONS_SUCCESS,
  payload: data
});

export const searchApplicationsFailure = data => ({
  type: SEARCH_APPLICATIONS_FAILURE,
  payload: data
});

export const setIsApplyEditApplication = isApplyEditApplication => ({
  type: IS_APPLY_EDIT_APPLICATION,
  payload: isApplyEditApplication
});

export const setErrorOccurredWhilePerforming = error => ({
  type: SET_ERROR_OCCURRED_WHILE_PERFORMING,
  payload: error
});

export const getProspectOverviewPromisify = prospectId => ({
  type: GET_PROSPECT_OVERVIEW_REQUEST,
  [WAIT_FOR_ACTION]: GET_PROSPECT_OVERVIEW_SUCCESS,
  [ERROR_ACTION]: GET_PROSPECT_OVERVIEW_FAIL,
  payload: {
    prospectId
  }
});

export const getProspectOverviewSuccess = prospect => ({
  type: GET_PROSPECT_OVERVIEW_SUCCESS,
  payload: { prospect }
});

export const getProspectOverviewFail = error => ({
  type: GET_PROSPECT_OVERVIEW_FAIL,
  error
});

export const loadMore = data => ({
  type: LOAD_MORE_SEARCH_APPLICATIONS,
  payload: data
});

export const loadMoreSearchApplicationsSuccess = data => ({
  type: LOAD_MORE_SEARCH_APPLICATIONS_SUCCESS,
  payload: data
});

export const loadMoreSearchApplicationsFailure = data => ({
  type: LOAD_MORE_SEARCH_APPLICATIONS_FAILURE,
  payload: data
});

export const updateRO = data => ({
  type: UPDATE_RO,
  [WAIT_FOR_ACTION]: UPDATE_RO_SUCCESS,
  [ERROR_ACTION]: UPDATE_RO_FAILURE,
  payload: data
});

export const updateROSuccess = data => ({
  type: UPDATE_RO_SUCCESS,
  payload: data
});

export const updateROFailure = data => ({
  type: UPDATE_RO_FAILURE,
  payload: data
});

export const getRoProspectPromisify = prospectId => ({
  type: GET_RO_PROSPECT_REQUEST,
  [WAIT_FOR_ACTION]: GET_RO_PROSPECT_REQUEST_SUCCESS,
  [ERROR_ACTION]: GET_RO_PROSPECT_REQUEST_FAILURE,
  payload: {
    prospectId
  }
});

export const getROSuccess = data => ({
  type: GET_RO_PROSPECT_REQUEST_SUCCESS,
  payload: data
});

export const getROFailure = error => ({
  type: GET_RO_PROSPECT_REQUEST_FAILURE,
  error
});

export const resetSearchResults = () => ({
  type: RESET_SEARCH_RESULTS
});

export const sendRequestForUserAuthorizationPromisify = (data, prospectId) => ({
  type: SEND_USER_DROPOFF_AUTHORIZE_REQ,
  [WAIT_FOR_ACTION]: SEND_USER_DROPOFF_AUTHORIZE_REQ_SUCCESS,
  [ERROR_ACTION]: SEND_USER_DROPOFF_AUTHORIZE_REQ_FAIL,
  payload: { data, prospectId }
});

export const sendDropOffAuthSuccess = () => ({
  type: SEND_USER_DROPOFF_AUTHORIZE_REQ_SUCCESS
});

export const sendDropOffAuthFail = () => ({
  type: SEND_USER_DROPOFF_AUTHORIZE_REQ_FAIL
});
